import React, { useState, useEffect } from 'react';

import { useNavigate } from "react-router-dom";
import Sidebar from '../SideBar/Sidebar';
import Title from '../Containers/Title';
import db from '../../Db/db';
import axios from "axios";
import { useParams } from "react-router-dom";
import PopupMessage from '../Containers/PopupMessage';

export default function NewVisite() {
    const navigate = useNavigate();
    const json = localStorage.getItem("token")
    const userInfo = JSON.parse(json);
    const [selectedOption, setSelectedOption] = useState("");
    const [clientsData, setClientsData] = useState([])
    const [clientSelect, setClientsSelect] = useState([])
    const [agenceData, setAgenceData] = useState([])
    const [activiteData, setActiviteData] = useState([])
    const [act, setAct] = useState([]);
    const [contact, setContact] = useState([]);
    const [clientContact, setClientContact] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [visitDateExt, setVisitDateExt] = useState('');
    const [depart, setDepart] = useState([]);

    const [materials, setMaterials] = useState([]);
    const [currentMaterial, setCurrentMaterial] = useState('');

    const months = [
        "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
        "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
    ];
    const daysOfWeek = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];


    const [popupMessage, setPopupMessage] = useState("");
    const [popupType, setPopupType] = useState("info");
    const [showPopup, setShowPopup] = useState(false);

    const showMessage = (message, type = "info") => {
        setPopupMessage(message);
        setPopupType(type);
        setShowPopup(true);
    };

    const [addContact, setAddContact] = useState([]);
    const [currentContact, setCurrentContact] = useState({
        nom: '',
        prenom: '',
        fonction: '',
        email: '',
        num: '',
        idContact: '',
    });

    const [etapes, setEtapes] = useState([]);
    const [steps, setSteps] = useState([]);
    const [currentStep, setCurrentStep] = useState({
        text: '',
        date: '',
    });



    const { id } = useParams();

    const [formData, setFormData] = useState({
        idCom: userInfo.user.idUser,
        topics: null,
        type: null,
        activite: null,
        site: null,
        ca: null,
        budget: null,
        nbPosMois: null,
        tonneMois: null,
        emballage: null,
        rapPoidVol: null,
        poidMoy: null,
        colis: null,
        palette: null,
        valMoyCol: null,
        assurance: null,
        heuramas: null,
        periLun: null,
        periMar: null,
        periMer: null,
        periJeu: null,
        periVen: null,
        periSam: null,
        periDim: null,
        saison: [],
        adressEnt: null,
        villeEnt: null,
        cpEnt: null,
        paysEnt: null,
        emailEnt: null,
        numEnt: null,
        codeClient: null,
        nextVisitDate: null,
        nomClient: null,
        idVisite: null
    });

    const dayFieldMap = {
        Lundi: 'periLun',
        Mardi: 'periMar',
        Mercredi: 'periMer',
        Jeudi: 'periJeu',
        Vendredi: 'periVen',
        Samedi: 'periSam',
        Dimanche: 'periDim',
    };
    

    useEffect(() => {
        if (message || error) {
            const timer = setTimeout(() => {
                setMessage("");
                setError("");
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [message, error]);

    useEffect(() => {
        async function fetchData() {
            setLoading(true); 
            const data1 = await db.clients.toArray();
            setClientsData(data1);
            const data8 = await db.contacts.toArray();
            setContact(data8);
            const data2 = await db.agences.toArray();
            setAgenceData(data2);
            
            const data9 = await db.depart.toArray();
            setDepart(data9)

            const data3 = await db.activite.toArray();
            setActiviteData(data3);
            const data4 = await db.matos.toArray();
            setAct(data4);

            const data5 = await db.etapes.toArray();
            setEtapes(data5)





            if (id) {
                const data = await db.visites.toArray();
                const visit = data.find(visit =>visit.id == id );
                console.log(visit)
                if (visit) {
                    const formattedDateVisite = visit.dateVisite ? new Date(visit.dateVisite).toISOString().split('T')[0] : '';
                    const formattedNextVisitDate = visit.nextVisitDate ? new Date(visit.nextVisitDate).toISOString().split('T')[0] : '';
                    const moisSaison = visit.saison?.map(s => s.saison) || [];

                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        idCom: visit.idUser,
                        topics: visit.action || visit.commentaire,
                        type: visit.typeClient,
                        activite: visit.activite,
                        site: visit.codeAgence,
                        ca: visit.caAnnuel,
                        budget: visit.budgetTL,
                        nbPosMois: visit.nbPosMois,
                        tonneMois: visit.tonneMois,
                        emballage: visit.emballage,
                        rapPoidVol: visit.rapPoidVol,
                        poidMoy: visit.poidMoy,
                        colis: visit.colis,
                        palette: visit.palette,
                        valMoyCol: visit.valMoyCol,
                        assurance: visit.assurance,
                        heuramas: visit.heuramas,
                        periLun: visit.periLun,
                        periMar: visit.periMar,
                        periMer: visit.periMer,
                        periJeu: visit.periJeu,
                        periVen: visit.periVen,
                        periSam: visit.periSam,
                        periDim: visit.periDim,
                        saison: moisSaison,
                        adressEnt: visit.adressClient,
                        villeEnt: visit.villeClient,
                        cpEnt: visit.cpClient,
                        paysEnt: visit.paysClient,
                        emailEnt: visit.emailClient,
                        numEnt: visit.telClient,
                        codeClient: visit.codeClient,
                        nextVisitDate: formattedNextVisitDate,
                        nomClient: visit.nomClient,
                        idVisite: id,
                        dateVisite: formattedDateVisite,
                    }));

                        setVisitDateExt(formattedDateVisite);
                        setSelectedOption(visit.typeClient);

                        setAddContact(data8.filter(c => c.idVisite === visit.id))
                        setClientContact(
                            data8.filter(c => 
                                c.codeClient === visit.codeClient &&
                                c.codeAgence === visit.codeAgence &&
                                !data8.some(addC => addC.idVisite === visit.id && addC.id === c.id)
                            )
                        );
                        setDeps(data9.filter(d => d.codeClient === visit.codeClient && d.codeAgence === visit.codeAgence))
            
                        setMaterials(
                            data4
                                .filter(a => a.codeClient === visit.codeClient && a.codeAgence === visit.codeAgence)
                                .map(a => a.materiel)
                        );
                        setSteps(
                            data5
                            .filter(s => s.codeClient === visit.codeClient && s.codeAgence === visit.codeAgence)
                            .map(s => ({
                                text: s.sujet,
                                date: s.date
                            }))
                        )

                                           
                }
            }
            setLoading(false);
        }
    
        fetchData();
        
    }, [id, userInfo.user.idUser]);

    

console.log("formData", formData)
    const handleOptionChange = (event) => {
        setClientsSelect(clientsData.filter(cli => cli.typeClient === event.target.value))
        setSelectedOption(event.target.value);
        setFormData({
            ...formData,
            [event.target.name]: event.target.value
        });
    };

  
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }));
    
        if (name === 'client') {
            const [nomClient, codeAgence, codeClient] = value.split(' / ');
    
            setClientContact(contact.filter(cont => cont.codeClient === codeClient && cont.codeAgence === codeAgence));
            setDeps(depart.filter(d => d.codeClient === codeClient && d.codeAgence === codeAgence))
            
            setMaterials(
                act
                    .filter(a => a.codeClient === codeClient && a.codeAgence === codeAgence)
                    .map(a => a.materiel)
            );
            setSteps(
                etapes
                .filter(s => s.codeClient === codeClient && s.codeAgence === codeAgence)
                .map(s => ({
                    text: s.sujet,
                    date: s.date
                }))
            )


        
    
            /*if (codeClient.includes('_PARENT')) {
                const allenfants = clientsData.filter(client => client.codeClient === codeClient && client.codeAgence === codeAgence);
                const all = [];
                const all2 = [];
                allenfants.forEach(client => {
                    if (client.enfants && client.enfants.length > 0) {
                        const filteredData = cityChargData.filter(item =>
                            client.enfants.some(enfant =>
                                item.idClient === enfant.enfant && item.codeAgence === enfant.agence
                            )
                        );
                        all.push(...filteredData);
                        const filteredData2 = cityLivrData.filter(item =>
                            client.enfants.some(enfant =>
                                item.idClient === enfant.enfant && item.codeAgence === enfant.agence
                            )
                        );
                        all2.push(...filteredData2);
                    }
                });
                setCityCharg(all);
                setCityLivr(all2);
            } else {
                setCityCharg(cityChargData.filter(client => client.idClient === codeClient && client.codeAgence === codeAgence));
                setCityLivr(cityLivrData.filter(client => client.idClient === codeClient && client.codeAgence === codeAgence));
            }*/
        }
    
        
    };

    const handleSaisonChange = (index) => {
        setFormData((prevFormData) => {
            const saison = prevFormData.saison.includes(index)
                ? prevFormData.saison.filter((mois) => mois !== index)
                : [...prevFormData.saison, index];
            return {
                ...prevFormData,
                saison,
            };
        });
    };

    const handlePeriodicityChange = (day) => {
        const fieldName = dayFieldMap[day];
        setFormData((prevFormData) => ({
            ...prevFormData,
            [fieldName]: prevFormData[fieldName] ? 0 : 1,
        }));
    };

    
    const handleChangeDate = (event) => {
        const { value } = event.target;
        const visitDate = new Date(value);
        const nextVisitDate = new Date(visitDate);
        nextVisitDate.setFullYear(nextVisitDate.getFullYear() + 1);

        setVisitDateExt(value);
        setFormData((prevFormData) => ({
            ...prevFormData,
            dateVisite: value,
            nextVisitDate: nextVisitDate.toISOString().split('T')[0],
        }));
    };

    
    const handleAddStep = () => {
        if (currentStep.text !== '' && currentStep.date !== '') {
          setSteps([...steps, currentStep]);
          setCurrentStep({
            text: '',
            date: '',
          });

        }
    };

    const handleAddContact = () => {
        if (currentContact !== '') {
            setAddContact([...addContact, currentContact]);
            setCurrentContact({
                nom: '',
                prenom: '',
                fonction: '',
                email: '',
                num: '',
                idContact: '',
            });
            setClientContact([
                ...clientContact,
                {
                    id: Date.now(),
                    codeClient: Date.now(),
                    codeAgence: "HRX",
                    nom: currentContact.nom,
                    prenom: currentContact.prenom,
                    fonction: currentContact.fonction || null,
                    mailContact: currentContact.email || null,
                    telContact: currentContact.num || null,
                    dateVisite: null,
                    isActive: 1,
                    updateDate: new Date().toISOString(),
                },
            ]);
        }
    }

    
    const handleAddMaterial = () => {
        if (currentMaterial !== '') {
          setMaterials([...materials, currentMaterial]);
          setCurrentMaterial('');
        }
    };
    const handleRMMaterial = (indexToRemove) => {
        setMaterials(materials.filter((_, index) => index !== indexToRemove));
    }

    const [deps, setDeps] = useState([]);
    const [currentDep, setCurrentDep] = useState({
        pays: '',
        ville: '',
        cp: '',
    });
    const handleAddDep = () => {
        if (currentDep !== '') {
          setDeps([...deps, currentDep]);
          setCurrentDep({
            pays: '',
            ville: '',
            cp: '',
          });
        }
    };
    const [online, setOnline] = useState(true);
    const checkConnection = async () => {
        try {
            await axios.get('https://api.hautier-transports.fr/crm');
            setOnline(true); 
            
        } catch (error) {
            setOnline(false);  
        }
    };

    
    const handleSubmit = async (event) => {
        
        checkConnection(); 
        event.preventDefault();
        


        
        const doc = document.getElementById('docExt');
        const url = doc && doc.files && doc.files.length > 0 ? doc.files[0].name : null;
            
        const docu = doc && doc.files && doc.files.length > 0 ? doc.files[0] : null;

        console.log(formData)

        axios.post('https://api.hautier-transports.fr/crm/visit/createUpd2', {
            formData, 
            etapes: steps,
            materials: materials, 
            deps: deps,
            url: url,
            docu: docu,
            visitDate: visitDateExt,
            addContact: addContact,
            
        }, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-type": 'multipart/form-data',
                'Authorization': 'Bearer ' + userInfo.token
            }
        }).then(function (response) {
           // console.log('Réponse du serveur:', response.data);
            //showMessage("La visite a bien été envoyée !", "info")
           
        }).catch(function (error) {
            console.error('Erreur lors de la soumission du formulaire:', error);
            showMessage("Échec de l'envoi de la visite. Veuillez réessayer.", "error");
            setMessage("");
        });

        try {
            
            let newId = ''
            if (id){
                newId = parseInt(id, 10);
            }else{
                const maxId = await db.visites.orderBy('id').last();
                newId = maxId ? maxId.id + 1 : 1;
            }

            const fieldMapping = {
                activite: "activite",
                adressEnt: "adressClient",
                budget: "budgetTL",
                ca: "caAnnuel",
                nbPosMois: "nbPosMois",
                tonneMois: "tonneMois",
                emballage: "emballage",
                rapPoidVol: "rapPoidVol",
                poidMoy: "poidMoy",
                colis: "colis",
                palette: "palette",
                valMoyCol: "valMoyCol",
                assurance: "assurance",
                heuramas: "heuramas",
                periLun: "periLun",
                periMar: "periMar",
                periMer: "periMer",
                periJeu: "periJeu",
                periVen: "periVen",
                periSam: "periSam",
                periDim: "periDim",
                saison: "saison",
                codeClient: "codeClient",
                cpEnt: "cpClient",
                dateVisite: "dateVisite",
                emailEnt: "emailClient",
                idCom: "idUser",
                idVisite: "id",
                nextVisitDate: "nextVisitDate",
                nomClient: "nomClient",
                numEnt: "telClient",
                paysEnt: "paysClient",
                site: "codeAgence",
                topics: "action",
                type: "typeClient",
                villeEnt: "villeClient"
            };
            
            const dbData = Object.keys(formData).reduce((acc, key) => {
                const dbKey = fieldMapping[key];
                if (dbKey) {
                    acc[dbKey] = formData[key];
                }
                return acc;
            }, {});
            
            if (id) { 
                console.log(1)
                const existingVisit = await db.visites.get(parseInt(id, 10));
                if (existingVisit) {
                    await db.visites.put({
                        ...existingVisit, 
                        ...dbData,
                        saison: formData.saison.map(m => ({ saison: m })),
                        id: parseInt(id, 10)
                    });
                    console.log('Visite mise à jour avec succès :', id);
                    showMessage("Visite mise à jour avec succès !", "info");

                } else {
                    console.log(2)
                    
                    console.error('Visite non trouvée pour la mise à jour :', id);
                    showMessage('Visite non trouvée pour la mise à jour.', "error");
                }
            } else {
                try {
                    const maxId = await db.visites.orderBy('id').last();
                    let newId = maxId ? maxId.id + 1 : 1;
                    
                    console.log(3);
                    const newVisit = {
                        id: newId,
                        name: userInfo.user.name,
                        firstname: userInfo.user.firstName,
                        idUser: userInfo.user.idUser,
                        dateVisite: visitDateExt,
                        action: formData.topics,
                        activite: formData.activite,
                        urlDoc: '',
                        codeClient: formData.codeClient,
                        nomClient: formData.nomClient,
                        codeAgence: formData.site,
                        //typeClient: formData.typeClient,
                        typeClient: formData.type,
                        typeVisite :"visite",
                        adressClient: formData.adressEnt,
                        adresse2: formData.adressEnt,
                        cpClient: formData.cpEnt,
                        villeClient: formData.villeEnt,
                        paysClient: formData.paysEnt,
                        telClient: formData.numEnt,
                        emailClient: formData.emailEnt,
                        budgetTL: formData.budget,
                        caAnnuel: formData.ca,
                        emballage: formData.emballage,
                        rapPoidVol: formData.rapPoidVol,
                        poidMoy: formData.poidMoy,
                        colis: formData.colis,
                        palette: formData.palette,
                        valMoyCol: formData.valMoyCol,
                        assurance: formData.assurance,
                        heuramas: formData.heuramas,
                        periLun: formData.periLun,
                        periMar: formData.periMar,
                        periMer: formData.periMer,
                        periJeu: formData.periJeu,
                        periVen: formData.periVen,
                        periSam: formData.periSam,
                        periDim: formData.periDim,
                        saison: formData.saison.map(m => ({ saison: m })),
                        //commentaire: formData.commentaire,
                      };
                      
                      console.log(" Données complètes pour db.visites.put:", newVisit);
                      
                      
                      Object.keys(newVisit).forEach(key => {
                        if (newVisit[key] === undefined) {
                          delete newVisit[key];
                        }
                      });
                      
                      console.log("Nettoyé :", newVisit);
                      
                      await db.visites.put(newVisit);
                    console.log('Nouvelle visite ajoutée avec succès');
                    showMessage('Nouvelle visite ajoutée avec succès !', "info");
                  } catch (e) {
                    console.error("Erreur lors de l'insertion IndexedDB :", e);
                    showMessage("Erreur lors de la sauvegarde locale de la visite.", "error");
                  }
            }
            let newCodeClient;
            if(formData.codeClient){
                newCodeClient = formData.codeClient;
            }else{
                const cleanNomClient = (formData.nomClient || "").replace(/\s+/g, '').toUpperCase();
                const randomId = Math.floor(1000 + Math.random() * 9000);
                newCodeClient = `${cleanNomClient}_${formData.site}_${randomId}`;
                formData.codeClient = newCodeClient;
            }
            const newClient = {
                codeClient: newCodeClient,
                codeAgence: formData.site,
                activite: formData.activite,
                nomClient: formData.nomClient,
                adressClient: formData.adressEnt,
                cpClient: formData.cpEnt,
                villeClient: formData.villeEnt,
                paysClient: formData.paysEnt,
                telClient: formData.numEnt,
                emailClient: formData.emailEnt,
                budgetTL: formData.budget,
                caAnnuel: formData.ca,
                emballage: formData.emballage,
                rapPoidVol: formData.rapPoidVol,
                poidMoy: formData.poidMoy,
                colis: formData.colis,
                palette: formData.palette,
                valMoyCol: formData.valMoyCol,
                assurance: formData.assurance,
                heuramas: formData.heuramas,
                periLun: formData.periLun,
                periMar: formData.periMar,
                periMer: formData.periMer,
                periJeu: formData.periJeu,
                periVen: formData.periVen,
                periSam: formData.periSam,
                periDim: formData.periDim,
                saison: formData.saison.map(m => ({ saison: m })),
                nbPosMois: formData.nbPosMois,
                tonneMois: formData.tonneMois,
                typeClient: formData.type,
                commercial: userInfo.user.idUser,
                enfant: null
            };
            console.log(" Données complètes pour db.clients.put:", newClient);
            await db.clients.put(newClient);
            

            const maxIdC = await db.contacts.orderBy('id').last();
            const newIdC = maxIdC ? maxIdC.id + 1 : 1;
            await addContact.map((c) => (
                db.contacts.put({
                    id: c.idContact || newIdC,
                    codeClient: formData.codeClient,
                    codeAgence: formData.site,
                    nom: c.nom,
                    prenom: c.prenom,
                    mailContact: c.email,
                    telContact: c.num,
                    tel2Contact: null,
                    fonction: c.fonction,
                    dateVisite: null,
                    updateDate: null,
                    isActive: 1

                })
            ));
            const maxIdE = await db.etapes.orderBy('id').last();
            const newIdE = maxIdE ? maxIdE.id + 1 : 1;
            await steps.map((e) => (

                 db.etapes.put({
                    id: newIdE,
                    sujet: e.text,
                    date: e.date,
                    idVisite: newId,
                    nomClient: formData.nomClient,
                    codeClient: formData.codeClient,
                    codeAgence: formData.site

                })
            ));
            //const depart = await db.etapes.put(id, {
            //});

            handleCancel();
            
        } catch (error) {
            showMessage("Erreur lors de la sauvegarde locale. Veuillez réessayer.", "error");
        }
        

    };


      const handleClientChange = (event) => {
        const selectedClient = event.target.value;
        const [nomClient, codeAgence, codeClient] = selectedClient.split(' / ');
        const client = clientsData.find(client => client.codeClient === codeClient && client.codeAgence === codeAgence);
        const moisSaison = client.saison?.map(s => s.saison) || [];

        if (client) {
            setFormData((prevFormData) => ({
                ...prevFormData,
                codeClient: client.codeClient,
                nomClient: client.nomClient,
                activite: client.activite,
                site: client.codeAgence,
                ca: client.caAnnuel,
                budget: client.budgetTL,
                emballage: client.emballage,
                rapPoidVol: client.rapPoidVol,
                poidMoy: client.poidMoy,
                colis: client.colis,
                palette: client.palette,
                valMoyCol: client.valMoyCol,
                assurance: client.assurance,
                heuramas: client.heuramas,
                periLun: client.periLun,
                periMar: client.periMar,
                periMer: client.periMer,
                periJeu: client.periJeu,
                periVen: client.periVen,
                periSam: client.periSam,
                periDim: client.periDim,
                saison: moisSaison,
                nbPosMois: client.nbPosMois,
                tonneMois: client.tonneMois,
                adressEnt: client.adressClient,
                villeEnt: client.villeClient,
                cpEnt: client.cpClient,
                paysEnt: client.paysClient,
                emailEnt: client.emailClient,
                numEnt: client.telClient,
                client: selectedClient
            }));
    
            handleChange({
                target: {
                    name: 'client',
                    value: selectedClient
                }
            });
        } else {
            console.error("Client not found or invalid selection");
        }
    }

    const handleCancel = () => {
        setFormData({
            idCom: userInfo.user.idUser,
            nom: null,
            prenom: null,
            fonction: null,
            email: null,
            num: null,
            topics: null,
            type: null,
            activite: null,
            site: null,
            ca: null,
            budget: null,
            emballage: null,
            rapPoidVol: null,
            poidMoy: null,
            colis: null,
            palette: null,
            valMoyCol: null,
            assurance: null,
            heuramas: null,
            periLun: null,
            periMar: null,
            periMer: null,
            periJeu: null,
            periVen: null,
            periSam: null,
            periDim: null,
            saison: [],
            nbPosMois: null,
            tonneMois: null,
            adressEnt: null,
            villeEnt: null,
            cpEnt: null,
            paysEnt: null,
            emailEnt: null,
            numEnt: null,
            codeClient: null,
            nextVisitDate: null,
            idContact: null,
            nomClient: null,
            idVisite: null
        });
        setSteps([]);
        setMaterials([]);
        setDeps([]);
        setSelectedOption("")
        setAddContact([]);
    };
   

    return (
    <div className='flex flex-row h-full w-full fixed'>
        <Sidebar />
        <div className="relative flex flex-col w-full h-full bg-bleuBlanc">
            <div className="h-[15%] w-full">
                <svg xmlns="http://www.w3.org/2000/svg" onClick={() => navigate(-1)} fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#113577" className="w-8 h-8 hover:stroke-roseLogo absolute top-[6%] left-10">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
                </svg>
                <Title title="Formulaire de nouvelle visite" btn={false} />
            </div>
            {!loading ? (
                
            <div className='flex flex-wrap mt-4 justify-center w-full h-full overflow-x-hidden overflow-y-auto scrollbar scrollbar-thin scrollbar-thumb-roseLogo scrollbar-track-grey100 max-h-full'>
                <PopupMessage 
                    message={popupMessage} 
                    type={popupType} 
                    show={showPopup} 
                    onClose={() => setShowPopup(false)} 
                />
                
                <form encType="multipart/form-data" className='flex flex-col w-full h-full' id='monFormulaire' onSubmit={handleSubmit}>
                    <div className='flex justify-between mr-8'>
                        {/**Premier champ cacher le reste du formulaire tant qu'il n'ai pas rempli */}
                        <div className="mb-4 ml-4 flex flex-col w-[30%] h-full">
                            <label htmlFor="type" className="block text-sm font-medium text-roseLogo ">
                                Type de client :
                            </label>
                            <select
                                name="type"
                                id="type"
                                className=" mx-4 border border-roseLogo hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border "
                                required
                                onChange={handleOptionChange}
                                value={selectedOption }
                                
                            >
                                <option value="">---</option>
                                <optgroup label="Via le formulaire">
                                <option value="prospect">Prospect</option>
                                <option value="client-effectif">Client Effectif</option>
                                <option value="parent">Client Parent</option>
                                <option value="nouveau-prospect">Nouveau Prospect</option>
                                </optgroup>
                                <optgroup label="Via un document">
                                <option value="docE">Ajout document (Existant)</option>
                                <option value="docN">Ajout document (Nouveau)</option>
                                </optgroup>
                            </select>
                        </div>
                        {selectedOption   ? (
                            <div className='w-[30%] mb-4 ml-4'>
                                <label htmlFor="visitDate" className="block text-sm font-medium text-roseLogo">
                                    Date de la visite:
                                </label>
                                <input
                                    type="date"
                                    name="visitDate"
                                    id="visitDate"
                                    className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-roseLogo focus:outline-none"
                                    onChange={handleChangeDate}
                                    value={visitDateExt}
                                    required
                                />
                            </div>
                        ) : null}

                        
                    </div>
                    
                    {selectedOption   ? (
                        <fieldset className="mb-4 mx-4">
                            {selectedOption === 'docN' || selectedOption === 'nouveau-prospect' ? (
                            <legend className="text-lg font-semibold mb-2 text-marineLogo">Création d'un nouveau Client / Prospect</legend>
                            ) :<legend className="text-lg font-semibold mb-2 text-marineLogo">Choix du Client / Prospect</legend>}
                            <div className='flex mx-4'>
                            {selectedOption === 'docN' || selectedOption === 'nouveau-prospect' ? (
                                <div className="mb-4 mr-[3%] w-[30%]">
                                    <label htmlFor="nomClient" className="block text-sm font-medium text-roseLogo">
                                        Nom de l'entreprise :
                                    </label>

                                    <input
                                        type="text"
                                        name="nomClient"
                                        id="nomClient"
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-roseLogo focus:outline-none"
                                        onChange={handleChange}
                                        value={formData.nomClient}
                                        required
                                    />
                                </div>
                                ) :
                                    <div className="mb-4 mr-[3%] w-[30%]">
                                        <label htmlFor="codeClient" className="block text-sm font-medium text-roseLogo">Liste des clients / prospects :</label>
                                        <input
                                            list="clients"
                                            name="codeClient"
                                            id="codeClient"
                                            className="mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-roseLogo focus:outline-none"
                                            onChange={handleClientChange}
                                            value={formData.codeClient}
                                        />
                                        <datalist id="clients">
                                            <option value="">Sélectionnez un client</option>
                                            {clientSelect.map((client, index) => (
                                                <option key={index} value={`${client.nomClient} / ${client.codeAgence} / ${client.codeClient}`}>
                                                    {client.codeClient + ' / ' + client.nomClient + ' / ' + client.codeAgence}
                                                </option>
                                            ))}
                                        </datalist>
                                    </div>
                                }
                                <div className="mb-4 mr-[3%] w-[30%]">
                                    <label htmlFor="activite" className="block text-sm font-medium text-roseLogo">
                                        Secteur d'activité :
                                    </label>
                                    <input
                                        type="text"
                                        name="activite"
                                        id="activite"
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-roseLogo focus:outline-none "
                                        onChange={handleChange}
                                        value={formData.activite || ""}
                                        required
                                    />
                                </div>
                                <div className="mb-4 w-[30%]">
                                    <label htmlFor="site" className="block text-sm font-medium text-roseLogo">
                                        Site :
                                    </label>
                                    <select
                                        name="site"
                                        id="site"
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-roseLogo focus:outline-none "
                                        onChange={handleChange}
                                        value={formData.site || ""}
                                        required
                                    >
                                        <option value="">Sélectionnez un site</option>
                                        {agenceData.map((agence, index) => 
                                            <option key={index} value={agence.code}>{agence.code}</option>
                                        )}
                                    </select>
                                </div>
                            </div>
               
                            <div className='flex mx-4'>
                                <div className="mb-4 mr-[3%] w-[100%]">
                                    <label htmlFor="saison" className="block text-sm font-medium text-marineLogo">Effet de saisonalité :</label>
                                    <div className="grid grid-cols-12 gap-3 mt-2 ml-[3%]">
                                        {months.map((month, index) => (
                                            <label key={index} className="flex items-center space-x-2 text-marineLogo">
                                                <input
                                                    type="checkbox"
                                                    value={month}
                                                    checked={(formData.saison || []).includes(index)}
                                                    onChange={() => handleSaisonChange(index)}
                                                    className="accent-marineLogo"
                                                />
                                                <span className="text-sm text-gray-700">{month}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            </div>
                  

                            <div className='flex mx-4'>
                                <div className="mb-4 mr-[3%] w-[30%]">
                                    <label htmlFor="adressEnt" className="block text-sm font-medium text-marineLogo">Adresse :</label>
                                    <input 
                                        type="text" 
                                        name="adressEnt" 
                                        id="adressEnt" 
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-marineLogo focus:outline-none " 
                                        onChange={handleChange}  
                                        value={formData.adressEnt || ""}
                                    />
                                </div>
                                <div className="mb-4 mr-[3%] w-[30%]">
                                    <label htmlFor="villeEnt" className="block text-sm font-medium text-roseLogo">Ville :</label>
                                    <input 
                                        type="text" 
                                        name="villeEnt" 
                                        id="villeEnt" 
                                        className="hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-roseLogo focus:outline-none " 
                                        onChange={handleChange} 
                                        value={formData.villeEnt || ""}
                                        required
                                    />
                                </div>
                                <div className="mb-4 mr-[3%] w-[30%]">
                                    <label htmlFor="cpEnt" className="block text-sm font-medium text-roseLogo">Code postal :</label>
                                    <input 
                                        type="text" 
                                        name="cpEnt"
                                        id="cpEnt" 
                                        className="hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-roseLogo focus:outline-none " 
                                        onChange={handleChange} 
                                        value={formData.cpEnt || ""}
                                        required
                                    />
                                </div>
                                <div className="mb-4 w-[30%]">
                                    <label htmlFor="paysEnt" className="block text-sm font-medium text-marineLogo">Pays :</label>
                                    <input 
                                        type="text" 
                                        name="paysEnt" 
                                        id="paysEnt" 
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-marineLogo focus:outline-none " 
                                        onChange={handleChange} 
                                        value={formData.paysEnt || ""}
                                    />
                                </div>
                            </div>
                            <div className='flex mx-4'>
                                <div className="mb-4 mr-[3%] w-[30%]">
                                    <label htmlFor="emailEnt" className="block text-sm font-medium text-marineLogo">Email standard :</label>
                                    <input 
                                        type="text" 
                                        name="emailEnt" 
                                        id="emailEnt" 
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-marineLogo focus:outline-none " 
                                        onChange={handleChange} 
                                        value={formData.emailEnt || ""}
                                    />
                                </div>
                                <div className="mb-4 w-[30%]">
                                    <label htmlFor="numEnt" className="block text-sm font-medium text-marineLogo">Téléphone standard :</label>
                                    <input 
                                        type="text" 
                                        name="numEnt" 
                                        id="numEnt" 
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-marineLogo focus:outline-none " 
                                        onChange={handleChange} 
                                        value={formData.numEnt || ""}
                                    />
                                </div>
                            </div>
                            <div className="mb-4 border-t border-marineLogo">
                            <label className="text-marineLogo"> Expedition </label>
                            <div className='flex  mx-4'>
                                <div className="mb-4 mr-[3%] w-[30%]">
                                    <label htmlFor="ca" className="block text-sm font-medium text-marineLogo">CA annuel :</label>
                                    <input 
                                        type="text" 
                                        name="ca" 
                                        id="ca" 
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-marineLogo focus:outline-none " 
                                        onChange={handleChange} 
                                        value={formData.ca || ""}
                                    />
                                </div>
                                <div className="mb-4 w-[30%]">
                                    <label htmlFor="budget" className="block text-sm font-medium text-marineLogo">Budget transport/logistique :</label>
                                    <input 
                                        type="text" 
                                        name="budget" 
                                        id="budget" 
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-marineLogo focus:outline-none " 
                                        onChange={handleChange} 
                                        value={formData.budget || ""}
                                        
                                    />
                                </div>
                            </div>


                        
                            <div className='flex  mx-4'>
                                <div className="mb-4 mr-[3%] w-[30%]">
                                    <label htmlFor="nbPosMois" className="block text-sm font-medium text-marineLogo">NB position / mois :</label>
                                    <input 
                                        type="text" 
                                        name="nbPosMois" 
                                        id="nbPosMois" 
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-marineLogo focus:outline-none " 
                                        onChange={handleChange} 
                                        value={formData.nbPosMois || ""}
                                    />
                                </div>
                                <div className="mb-4 w-[30%]">
                                    <label htmlFor="tonneMois" className="block text-sm font-medium text-marineLogo">Tonnage mensuel :</label>
                                    <input 
                                        type="text" 
                                        name="tonneMois" 
                                        id="tonneMois" 
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-marineLogo focus:outline-none " 
                                        onChange={handleChange} 
                                        value={formData.tonneMois || ""}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="mb-4">
                            <label className="text-marineLogo"> Nature du fret </label>
                            <div className='flex  mx-4'>
                                <div className="mb-4 mr-[3%] w-[30%]">
                                    <label htmlFor="emballage" className="block text-sm font-medium text-marineLogo">Emballage :</label>
                                    <input 
                                        type="text" 
                                        name="emballage" 
                                        id="emballage" 
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-marineLogo focus:outline-none " 
                                        onChange={handleChange}
                                        value={formData.emballage || ""}
                                    />
                                </div>
                                <div className="mb-4 mr-[3%] w-[30%]">
                                    <label htmlFor="rapPoidVol" className="block text-sm font-medium text-marineLogo">Rapport poids /volume :</label>
                                    <input 
                                        type="text" 
                                        name="rapPoidVol" 
                                        id="rapPoidVol" 
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-marineLogo focus:outline-none " 
                                        onChange={handleChange}
                                        value={formData.rapPoidVol || ""}
                                    />
                                </div>
                            </div>
                            <div className='flex  mx-4'>
                                
                                <div className="mb-4 mr-[3%] w-[30%]">
                                    <label htmlFor="poidMoy" className="block text-sm font-medium text-marineLogo">Pods moyen :</label>
                                    <input 
                                        type="text" 
                                        name="poidMoy" 
                                        id="poidMoy" 
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-marineLogo focus:outline-none " 
                                        onChange={handleChange}
                                        value={formData.poidMoy || ""} 
                                    />
                                </div>
                                <div className="mb-4 mr-[3%] w-[30%]">
                                    <label htmlFor="colis" className="block text-sm font-medium text-marineLogo">Colis :</label>
                                    <input 
                                        type="text" 
                                        name="colis" 
                                        id="colis" 
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-marineLogo focus:outline-none " 
                                        onChange={handleChange}
                                        value={formData.colis || ""}
                                    />
                                </div>
                                <div className="mb-4 w-[30%]">
                                    <label htmlFor="palette" className="block text-sm font-medium text-marineLogo">Palettes :</label>
                                    <input 
                                        type="text" 
                                        name="palette" 
                                        id="palette" 
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-marineLogo focus:outline-none " 
                                        onChange={handleChange}
                                        value={formData.palette || ""} 
                                    />
                                </div>
                            </div>
                            <div className='flex  mx-4'>
                                <div className="mb-4 mr-[3%] w-[30%]">
                                    <label htmlFor="valMoyCol" className="block text-sm font-medium text-marineLogo">Valeur moyenne par colis :</label>
                                    <input 
                                        type="text" 
                                        name="valMoyCol" 
                                        id="valMoyCol" 
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-marineLogo focus:outline-none " 
                                        onChange={handleChange}
                                        value={formData.valMoyCol || ""}
                                    />
                                </div>
                                <div className="mb-4 mr-[3%] w-[30%]">
                                    <label htmlFor="assurance" className="block text-sm font-medium text-marineLogo">
                                        Assurance :
                                    </label>
                                    <div className="mt-2 flex space-x-4 ml-[3%]">
                                        <label className="flex items-center space-x-2 text-marineLogo">
                                            <input
                                                type="radio"
                                                name="assurance"
                                                value="Occasionnelle"
                                                checked={formData.assurance === "Occasionnelle"}
                                                onChange={handleChange}
                                                className="accent-marineLogo"
                                            />
                                            <span className="text-sm text-gray-700">Occasionnelle</span>
                                        </label>
                                        <label className="flex items-center space-x-2 text-marineLogo">
                                            <input
                                                type="radio"
                                                name="assurance"
                                                value="Systématique"
                                                checked={formData.assurance === "Systématique"}
                                                onChange={handleChange}
                                                className="accent-marineLogo"
                                            />
                                            <span className="text-sm text-gray-700">Systématique</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className='flex  mx-4'>
                                
                                <div className="mb-4 mr-[3%] w-[30%]">
                                    <label htmlFor="poidmoy" className="block text-sm font-medium text-marineLogo">Horaire Ramasse :</label>
                                    <div className="mt-2 flex space-x-4 ml-[3%]">
                                        <label className="flex items-center space-x-2 ">
                                            <input
                                                 type="radio"
                                                 name="heuramas"
                                                 value="Sur Appel"
                                                 checked={formData.heuramas === "Sur Appel"}
                                                 onChange={handleChange}
                                                 className="accent-marineLogo"
                                            />
                                            <span className="text-sm text-marineLogo">Sur Appel</span>
                                        </label>
                                        <label className="flex items-center space-x-2">
                                            <input
                                                type="radio"
                                                name="heuramas"
                                                value="Quotidienne"
                                                checked={formData.heuramas === "Quotidienne"}
                                                onChange={handleChange}
                                                className="accent-marineLogo"
                                            />
                                            <span className="text-sm  text-marineLogo">Quotidienne</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="mb-4 w-[30%]">
                                    <label htmlFor="poidmoy" className="block text-sm font-medium text-marineLogo">Périodicité :</label>
                                    <div className="grid grid-cols-3 gap-2 mt-2 ml-[3%]">
                                        {daysOfWeek.map((day, index) => (
                                            <label key={index} className="flex items-center space-x-2 text-marineLogo">
                                                <input
                                                     type="checkbox"
                                                     checked={!!formData[dayFieldMap[day]]}
                                                     onChange={() => handlePeriodicityChange(day)}
                                                     className="accent-marineLogo"
                                                />
                                                <span className="text-sm text-gray-700">{day}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                            
{/*
                            <div className="mb-4">
                            <label className="text-marineLogo"> Tarifs </label>
                            <div className='flex  mx-4'>
                                <div className="mb-4 mr-[3%] w-[30%]">
                                <label className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        checked={""}
                                       // onChange={""}
                                        className="accent-marineLogo"
                                    />
                                    <span className="text-sm text-marineLogo">Zones Majo / Mino</span>
                                </label>
                                    <input 
                                        type="text" 
                                        name="poidmoy" 
                                        id="poidmoy" 
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-marineLogo focus:outline-none " 
                                       // onChange={""} 
                                        value={""} 
                                    />
                                </div>
                                <div className="mb-4 mr-[3%] w-[30%]">
                                    <label className="flex items-center space-x-2">
                                        <input
                                            type="checkbox"
                                            checked={""}
                                           // onChange={""}
                                            className="accent-marineLogo"
                                        />
                                        <span className="text-sm text-marineLogo">Palettes Majo / Mino</span>
                                    </label>
                                    <input 
                                        type="text" 
                                        name="poidmoy" 
                                        id="poidmoy" 
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-marineLogo focus:outline-none " 
                                       // onChange={""} 
                                        value={""} 
                                    />
                                </div>
                                <div className="mb-4 w-[30%]">
                                    <label className="flex items-center space-x-2">
                                        <input
                                            type="checkbox"
                                            checked={""}
                                           // onChange={""}
                                            className="accent-marineLogo"
                                        />
                                        <span className="text-sm text-marineLogo">Bout3 Majo / Mino</span>
                                    </label>
                                    <input 
                                        type="text" 
                                        name="poidmoy" 
                                        id="poidmoy" 
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-marineLogo focus:outline-none " 
                                       // onChange={""} 
                                        value={""} 
                                    />
                                </div>
                            </div>
                        </div>
*/}
                            <div className='border-t border-marineLogo'>
                                <div className="mb-4 mx-4 mt-4">
                                    <label htmlFor="material" className="block text-sm font-medium text-roseLogo">Type de besoin matériel :</label>
                                    <div className='flex items-center mx-4 '>
                                        <div className=' w-[30%]'>
                                            <input list="materialsList"
                                                name="material"
                                                id="material"
                                                className="hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-roseLogo focus:outline-none "
                                                onChange={(e) => setCurrentMaterial(e.target.value)}
                                                value={currentMaterial}
                                            />
                                            <datalist id="materialsList">
                                                {activiteData.map((act, index) =>
                                                    <option>{act.label}</option>
                                                )}
                                            </datalist>
                                        </div>
                                        <div className=''>
                                            <button
                                                type="button"
                                                className="ml-2 px-3 py-1 rounded-md hover:border hover:border-vertLogo focus:outline-none border border-roseLogo"
                                                onClick={handleAddMaterial}
                                            >
                                                +
                                            </button>
                                        </div>
                                    </div>
                                    {materials.length > 0 && (
                                    <div className="mb-4 mt-4">
                                        <ul className="space-y-2">
                                            {materials.map((material, index) => (
                                                <li
                                                    key={index}
                                                    className="flex items-center justify-between p-2 rounded-md border border-marineLogo w-1/2"
                                                >
                                                    <span className="text-sm font-medium text-marineLogo">{material}</span>
                                                    <button
                                                        type="button"
                                                        className="flex items-center justify-center w-6 h-6 text-white bg-roseLogo rounded-full hover:bg-red-600 focus:outline-none"
                                                        onClick={() => handleRMMaterial(index)}
                                                        title="Supprimer"
                                                    >
                                                        &times;
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                                </div>
                                
                                
                            </div>
                            <div className='border-t border-marineLogo'>
                                <div className="mb-4 mx-4 mt-4">
                                    <label className="block text-sm font-medium text-marineLogo">Points de départs principaux :</label>
                                    <div className="flex mx-4">
                                        <input
                                            type="text"
                                            name="paysText"
                                            id="paysText"
                                            className="hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block  mr-[3%] w-[30%] rounded-md border border-marineLogo focus:outline-none"
                                            value={currentDep.pays}
                                            onChange={(e) => setCurrentDep({ ...currentDep, pays: e.target.value })}
                                            placeholder="Pays de départ"
                                        />
                                        <input
                                            type="text"
                                            name="villeText"
                                            id="villeText"
                                            className="hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block  mr-[3%] w-[30%] rounded-md border border-marineLogo focus:outline-none"
                                            value={currentDep.ville}
                                            onChange={(e) => setCurrentDep({ ...currentDep, ville: e.target.value })}
                                            placeholder="Ville de départ"
                                        />
                                        <input
                                            type="text"
                                            name="cpText"
                                            id="cpText"
                                            className="hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block  w-[30%] rounded-md border border-marineLogo focus:outline-none"
                                            value={currentDep.cp}
                                            onChange={(e) => setCurrentDep({ ...currentDep, cp: e.target.value })}
                                            placeholder="Code postal départ"
                                        />
                                        <button
                                            type="button"
                                            className="ml-2 px-3 py-1 rounded-md hover:border hover:border-vertLogo focus:outline-none border border-marineLogo"
                                            onClick={handleAddDep}
                                        >
                                            +
                                        </button>
                                    </div>
                                    <div className="mb-4 mt-4">
                                        <ul className="space-y-2">
                                        {deps.map((dep, index) => (
                                            <li key={index} className="flex items-center justify-between p-2 rounded-md border border-marineLogo w-1/2">
                                                <span className="text-sm font-medium text-marineLogo">{dep.pays} {dep.ville} {dep.cp}</span>
                                            
                                            </li>
                                        ))}
                                        </ul>
                                    </div>
                                </div>    
                            </div>          
                        </fieldset>
                    ): null}

                    

                    {/** Si champ 1 à été selectionner sur "prospect" ou "client-effctif" ou "nouveau-prospect" */}
                    {selectedOption === 'prospect' || selectedOption === 'client-effectif' || selectedOption === 'parent' || selectedOption === 'nouveau-prospect' ? (
                        <fieldset className="mb-4 flex flex-col ml-4">
                            <legend className="text-lg font-semibold mb-2 text-marineLogo">
                                Déroulé de la visite
                            </legend>
                            <div className="mb-4 mx-4">
                                <div>
                                    <label className='text-marineLogo'>Interlocuteurs/trices</label>
                                    <div>
                                        <div className='flex'>
                                            <div className="mb-4 mr-[3%] w-[30%]">
                                                <label htmlFor="nom" className="block text-sm font-medium text-roseLogo">Nom :</label>
                                                <input 
                                                    type="text" 
                                                    name="nom" 
                                                    id="nom" 
                                                    className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-roseLogo focus:outline-none" 
                                                    onChange={(e) => setCurrentContact({ ...currentContact, nom: e.target.value })}
                                                    value={currentContact.nom}
                                                    list="clientNames"
                                                />
                                                <datalist id="clientNames">
                                                    {clientContact.map((client, index) => (
                                                    <option key={index} value={`${client.nom} ${client.prenom}`}>
                                                        {client.nom} {client.prenom}
                                                    </option>
                                                    ))}
                                                </datalist>
                                            
                                            </div>
                                            <div className="mb-4 mr-[3%] w-[30%]">
                                                <label htmlFor="prenom" className="block text-sm font-medium text-roseLogo">Prénom :</label>
                                                <input 
                                                    type="text"
                                                    name="prenom" 
                                                    id="prenom" 
                                                    className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-roseLogo focus:outline-none" 
                                                    onChange={(e) => setCurrentContact({ ...currentContact, prenom: e.target.value })}
                                                    value={currentContact.prenom}
                                                    
                                                />
                                            </div>
                                            <div className="mb-4 w-[30%]">
                                                <label htmlFor="fonction" className="block text-sm font-medium text-roseLogo">Fonction :</label>
                                                <input 
                                                    type="text" 
                                                    name="fonction" 
                                                    id="fonction" 
                                                    className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-roseLogo focus:outline-none" 
                                                    onChange={(e) => setCurrentContact({ ...currentContact, fonction: e.target.value })}
                                                    value={currentContact.fonction}
                                                />
                                            </div>
                                        </div>
                                        <div className='flex'>
                                            <div className="mb-4 mr-[3%] w-[30%]">
                                                <label htmlFor="email" className="block text-sm font-medium text-roseLogo">Email interlocuteur :</label>
                                                <input 
                                                    type="email" 
                                                    name="email" 
                                                    id="email" 
                                                    className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-roseLogo focus:outline-none" 
                                                    onChange={(e) => setCurrentContact({ ...currentContact, email: e.target.value })}
                                                    value={currentContact.email}
                                                />
                                            </div>
                                            <div className="mb-4 w-[30%]">
                                                <label htmlFor="num" className="block text-sm font-medium text-roseLogo">Telephone interlocuteur :</label>
                                                <input 
                                                    type="text" 
                                                    maxlength="25"
                                                    name="num" 
                                                    id="num" 
                                                    className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-roseLogo focus:outline-none " 
                                                    onChange={(e) => setCurrentContact({ ...currentContact, num: e.target.value })}
                                                    value={currentContact.num}
                                                />
                                            </div>
                                            <div className="w-[30%]">
                                                <button
                                                    type="button"
                                                    className="mx-6 mt-5 px-3 py-1 rounded-md hover:border hover:border-vertLogo focus:outline-none border border-roseLogo"
                                                    onClick={handleAddContact}
                                                >
                                                    +
                                                </button>
                                            </div>
                                        </div>
                                        <input type="hidden" name="idContact" id="idContact" value={currentContact.idContact} />
                                    </div>
                                    <div className="flex flex-row">
                                        <div className="flex-1">
                                            <p className="text-base font-semibold text-marineLogo mb-4">Interlocuteurs/trices</p>
                                            {addContact.length > 0 ? (
                                                <div className="space-y-4">
                                                    {addContact.map((contact, index) => (
                                                        <div
                                                            key={index}
                                                            className="border border-vertLogo rounded-lg p-2 bg-vertLogo/10"
                                                            onClick={() => {
                                                                setAddContact(addContact.filter((c) => c.email !== contact.email));
                                                            }}
                                                        >
                                                            <h3 className="text-lg font-semibold text-vertLogo">
                                                                {contact.nom} {contact.prenom}
                                                            </h3>
                                                            <p className="text-sm text-marineLogo">Fonction : {contact.fonction || "Non renseigné"}</p>
                                                            <p className="text-sm text-marineLogo">Email : {contact.email || "Non renseigné"}</p>
                                                            <p className="text-sm text-marineLogo">Téléphone : {contact.num || "Non renseigné"}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <p className="text-sm text-marineLogo">Aucun contact ajouté à cette visite.</p>
                                            )}
                                        </div>
                                        <div className="w-[2px] bg-marineLogo mx-6"></div>
                                        <div className="flex-1">
                                            <p className="text-base font-semibold text-marineLogo mb-4">Tous les contacts du client</p>
                                            {clientContact.length > 0 ? (
                                                <div className="space-y-4">
                                                    {clientContact
                                                        .filter(
                                                            (cont) => !addContact.some((addCont) => addCont.email === cont.mailContact)
                                                        )
                                                        .map((cont, index) => (
                                                            <div
                                                                key={index}
                                                                className="border border-marineLogo rounded-lg p-2 hover:border-vertLogo transition-shadow"
                                                                onClick={() =>
                                                                    setAddContact([
                                                                        ...addContact,
                                                                        {
                                                                            idContact: cont.id,
                                                                            nom: cont.nom,
                                                                            prenom: cont.prenom,
                                                                            fonction: cont.fonction,
                                                                            email: cont.mailContact,
                                                                            num: cont.telContact,
                                                                        },
                                                                    ])
                                                                }
                                                            >
                                                                <h3 className="text-lg font-semibold text-roseLogo">
                                                                    {cont.nom} {cont.prenom}
                                                                </h3>
                                                                <p className="text-sm text-marineLogo">Fonction : {cont.fonction}</p>
                                                                <p className="text-sm text-marineLogo">Email : {cont.mailContact || "Non renseigné"}</p>
                                                                <p className="text-sm text-marineLogo">Téléphone : {cont.telContact || "Non renseigné"}</p>
                                                            </div>
                                                        ))}
                                                </div>
                                            ) : (
                                                <p className="text-sm text-marineLogo">Aucun contact disponible pour ce client.</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="mb-4 mr-12">
                                    <label htmlFor="topics" className="block text-sm font-medium text-roseLogo">Sujets évoqués :</label>
                                    <textarea 
                                        name="topics" 
                                        id="topics" 
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-roseLogo focus:outline-none" 
                                        onChange={handleChange}  
                                        value={ formData.topics }
                                        required  
                                        rows="10"
                                    />
                                </div>
                                <div className="mb-4">
                                    <label htmlFor="steps" className="block text-sm font-medium text-roseLogo">
                                        Étapes suivantes :
                                    </label>
                                    <div className="flex mx-4 ">
                                        <input
                                            type="text"
                                            name="stepText"
                                            id="stepText"
                                            className="hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block  mr-[3%] w-[30%] rounded-md border border-roseLogo focus:outline-none"
                                            placeholder="Ajouter une étape"
                                            onChange={(e) => setCurrentStep({ ...currentStep, text: e.target.value })}
                                            value={currentStep.text}
                                        />
                                        <input
                                            type="date"
                                            name="stepDate"
                                            id="stepDate"
                                            className="hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-[30%] rounded-md border border-roseLogo focus:outline-none"
                                            placeholder="Date"
                                            onChange={(e) => setCurrentStep({ ...currentStep, date: e.target.value })}
                                            value={currentStep.date}
                                            
                                        />
                                        <button
                                            type="button"
                                            className="ml-2 px-3 py-1 hover:border hover:border-vertLogo rounded-md focus:outline-none border border-roseLogo"
                                            onClick={handleAddStep}
                                        >
                                            +
                                        </button>
                                    </div>
                                    <div className="mb-4 mt-4">
                                        <ul className="space-y-2">
                                        {steps.map((step, index) => (
                                            <li key={index} className="flex items-center justify-between p-2 rounded-md border border-marineLogo w-1/2">
                                                <span className="text-sm font-medium text-marineLogo">{step.text} ({step.date})</span>
                                            
                                            </li>
                                        ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="mb-4 w-[30%]">
                                    <label htmlFor="nextVisitDate" className="block text-sm font-medium text-roseLogo">Date de la prochaine visite :</label>
                                    <input 
                                        type="date" 
                                        name="nextVisitDate" 
                                        id="nextVisitDate" 
                                        required  
                                        className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-roseLogo focus:outline-none" 
                                        onChange={handleChange}
                                        value={formData.nextVisitDate}
                                    />
                                </div>
                            </div>
                        </fieldset>
                    ) : null }
                    {/** Si champ 1 à été selectionner sur "docE" ou "docN" */}
                    {selectedOption === 'docE' || selectedOption === 'docN' ? (
                        <div className='flex ml-4'>
                            <div className="mb-4 mr-[3%] w-[30%]">
                                <label htmlFor="clients" className="block text-sm font-medium text-marineLogo">Ajouter le document:</label>
                                <input
                                    type="file"
                                    name="docExt"
                                    id="docExt"
                                    className=" mx-4 hover:border hover:border-vertLogo focus:border focus:border-vertLogo mt-1 block w-full rounded-md border border-marinelogo focus:outline-none"
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>
                    ): null}
                    {selectedOption  ? (
                        <div className="flex justify-end">
                            <button type="submit" onClick={checkConnection} className='bg-vertLogo w-[20%] flex items-center rounded-lg text-blanc justify-center group hover:border hover:border-vertLogo focus:border focus:border-vertLogo hover:bg-blanc hover:text-vertLogo'>
                                Soumettre
                            </button>
                            <button
                                type="button"
                                className="hover:border hover:border-roseLogo hover:bg-blanc hover:text-roseLogo mr-2 px-4 py-2 rounded-md border border-marineLogo text-marineLogo bg-blanc focus:outline-none"
                                onClick={handleCancel}
                            >
                                Annuler
                            </button>
                        </div>
                    ) : null }
                </form>
            </div>
            ): null}  
        </div>
    </div>
    );
}